/**
 * Footer.jsx
 * Refined footer with the CMS admin/logout controls preserved.
 */

import {useContext} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFeather } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

import {useNavHelper} from '#hooks/useNavHelper';
import { AppStateContext } from '#App';

export function Footer(){
	const navigate = useNavHelper();
	const {session, userSession} = useContext(AppStateContext);
	const [sessionState, setSessionState] = session;

	let admin_links;
	if(sessionState === true){
		const doLogout = async (e)=>{
			e.preventDefault();
			await userSession.logout();
			setSessionState(false);
			navigate('/');
		};
		admin_links = <> · <a href='#' onClick={doLogout}>Logout</a> · <Link to="/admin">Admin</Link></>;
	}else{
		admin_links = <> · <Link to="/admin">Admin</Link></>;
	}

	return (<footer className="site-footer">
		<span>
			<FontAwesomeIcon className="fx" icon={faFeather} /> © {new Date().getFullYear()} Robert Parham · Tampa Bay, FL{admin_links}
		</span>
	</footer>);
}
